const generateDiscountCode = (length: number = 10): string => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let discountCode = '';

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    discountCode += characters[randomIndex];
  }

  return discountCode;
};

export default generateDiscountCode;
